import { findObjectForPropertyInModelContext, IModelContext } from '@mng/model';
import { UvAngebotData, UvPerson } from '../uvangebot.model.types';
import { ITEM_UV_PERSONEN_DATA, ITEM_UV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN } from '../uvangebot.model.paths';

export function getUvAngebotDataFromContext(modelContext: IModelContext): UvAngebotData {
  return findObjectForPropertyInModelContext(modelContext, ITEM_UV_PERSONEN_DATA);
}

export function getUvPersonFromContext(modelContext: IModelContext): UvPerson {
  return findObjectForPropertyInModelContext(modelContext, ITEM_UV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN);
}
